import { motion } from "framer-motion";
import {
  Microscope, HeartHandshake, UserCog, Eye, TrendingUp, Shield, Cpu,
} from "lucide-react";

const REASONS = [
  { icon: Microscope, title: "Research-Driven Investing", desc: "Every recommendation is backed by quantitative analysis and macro insight — never tips or trends." },
  { icon: HeartHandshake, title: "Client-First Philosophy", desc: "We work to suggest what's best for you. Our incentives are structurally aligned to your long-term outcomes." },
  { icon: UserCog, title: "Personalized Investor Solutions", desc: "Portfolios calibrated to your life-stage, cash flows, taxes and aspirations — not a template." },
  { icon: Eye, title: "Transparent Process", desc: "Clear scheme rationale, costs, and performance reporting on every recommendation." },
  { icon: TrendingUp, title: "Long-Term Wealth Creation", desc: "We optimise for decades, not quarters — compounding rewards patience and process." },
  { icon: Shield, title: "Risk Management", desc: "Diversification, downside guardrails and rebalancing built into every portfolio." },
  { icon: Cpu, title: "Technology-Enabled", desc: "Digital onboarding, paperless transactions and real-time portfolio dashboards." },
];

export default function WhyAxomind() {
  return (
    <section id="why" data-testid="why-section" className="section relative bg-[#050505]">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <p className="text-xs tracking-[0.35em] uppercase text-[#D4AF37]">Why Axomind</p>
          <h2 className="font-display font-bold text-4xl sm:text-5xl lg:text-6xl text-white mt-4 leading-[1.05]">
            Seven reasons clients
            <span className="text-gold-gradient"> stay with us.</span>
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {REASONS.map((r, i) => {
            const Icon = r.icon;
            const featured = i === 0;
            return (
              <motion.div
                key={r.title}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ duration: 0.5, delay: i * 0.05 }}
                data-testid={`why-card-${i}`}
                className={`relative rounded-2xl p-7 border transition-all duration-500 hover:-translate-y-1 ${
                  featured
                    ? "bg-gradient-to-br from-[#1A1407] via-[#0F0B05] to-[#050505] border-[#D4AF37]/40 lg:col-span-1"
                    : "bg-[#111111] border-white/8 hover:border-[#D4AF37]/40"
                }`}
              >
                <div className={`w-12 h-12 rounded-xl flex items-center justify-center mb-5 ${
                  featured ? "bg-[#D4AF37] text-black" : "bg-[#D4AF37]/10 text-[#D4AF37] border border-[#D4AF37]/30"
                }`}>
                  <Icon size={22} />
                </div>
                <h3 className="font-display font-semibold text-xl text-white">{r.title}</h3>
                <p className="text-gray-400 mt-2 text-sm leading-relaxed">{r.desc}</p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
